export default function getSitesTableFields(ctx) {
	return [
		{
			field: "order_id",
			title: ctx.$t("orderId"),
			align: "center"
		},
		{
			field: "income",
			title: ctx.$t("stats.income") + ", €",
			align: "center"
		},
		{
			field: "manager",
			title: ctx.$t("stats.manager"),
			align: "center"
		},
		{
			field: "website",
			title: ctx.$t("site"),
			align: "center"
		},
		{
			field: "date",
			title: ctx.$t("date"),
			align: "center"
		}
	];
}
